import gql from "graphql-tag";

const FORMS_QUERY = gql`
    {
    forms{
      id
      title
      description
      config{
        protected
        schema
      }
      submissionCount
    }
  }
`;
export default FORMS_QUERY;